export const FULL_KEYS = [
  {
    id: 'c3',
    repKey: 'a',
    label: 'C3',
    color: 'red'
  },
  {
    id: 'd3',
    repKey: 's',
    label: 'D3',
    color: 'orange'
  },
  {
    id: 'e3',
    repKey: 'd',
    label: 'E3',
    color: 'yellow'
  },
  {
    id: 'f3',
    repKey: 'f',
    label: 'F3',
    color: 'green'
  },
  {
    id: 'g3',
    repKey: 'g',
    label: 'G3',
    color: 'cyan'
  },
  {
    id: 'a3',
    repKey: 'h',
    label: 'A3',
    color: 'blue'
  },
  {
    id: 'b3',
    repKey: 'j',
    label: 'B3',
    color: 'magenta'
  },
  {
    id: 'c4',
    repKey: 'k',
    label: 'C4',
    color: 'red'
  }
];

export const HALF_KEYS = [
  {
    id: 'c3s',
    repKey: 'w',
    label: 'C#3',
    leftPos: '58'
  },
  {
    id: 'd3s',
    repKey: 'e',
    label: 'D#3',
    leftPos: '140'
  },
  {
    id: 'f3s',
    repKey: 't',
    label: 'F#3',
    leftPos: '304'
  },
  {
    id: 'g3s',
    repKey: 'y',
    label: 'G#3',
    leftPos: '386'
  },
  {
    id: 'a3s',
    repKey: 'u',
    label: 'A#3',
    leftPos: '468'
  }
];
